import react, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import jMoment from "moment-jalaali";
import RowInProgressDoctors from "./InProgressRowDoctors";

const InProgressTableDoctors = (props) => {
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    props.getPage(value);
  };

  return (
    <>
      <TableContainer aria-label="simple table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" />
              <TableCell align="center">شماره جعبه</TableCell>
              <TableCell align="center">تاریخ شروع</TableCell>
              <TableCell align="center">نام بیمار</TableCell>
              <TableCell align="center">نام لابراتوار</TableCell>
              <TableCell align="center">نوع کار</TableCell>
              <TableCell align="center">آخرین خروج</TableCell>
              <TableCell align="center">پیش بینی ورود</TableCell>
              <TableCell align="center">وضعیت</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((order) => {
              return (
                <RowInProgressDoctors
                  key={order.id}
                  orderId={order.id}
                  startDate={jMoment(Number(order.startDate)).format(
                    "jYY/jMM/jDD"
                  )}
                  boxNumber={order.boxNumber}
                  patientName={order.patientName}
                  labName={order.labName}
                  orderType={order.orderType}
                  lastEntrance={jMoment(Number(order.startDate)).format(
                    "jYY/jMM/jDD"
                  )}
                  exitPrediction={jMoment(Number(order.predictionDate)).format(
                    "jYY/jMM/jDD"
                  )}
                  condition={order.delation}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        sx={{ mt: 4, justifyContent: "center", display: "flex" }}
        count={props.pageCount}
        // page={page}
        onChange={handleChange}
      />
    </>
  );
};

export default InProgressTableDoctors;
